import { render, staticRenderFns } from "./ProfilePage_data.vue?vue&type=template&id=cf906ec0&scoped=true&"
import script from "./ProfilePage_data.vue?vue&type=script&lang=js&"
export * from "./ProfilePage_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf906ec0",
  null
  
)

export default component.exports